export default "__VITE_ASSET__CyZg6taI__"